module.exports = __webpack_public_path__ + "img/ic_launcher.7506fc20.png";